import { render } from "./HoursForm.vue?vue&type=template&id=89e44c44"
import script from "./HoursForm.vue?vue&type=script&lang=js"
export * from "./HoursForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__